import React, { Component } from "react";
import { connect } from "react-redux";
import { getConfig, getGlobalScriptsForCustomer, redeemEntryCode } from "../actions/RandomizerAction";
import { loadLocale } from "../actions/LocaleAction";
import "./App.css";
import { Trans, initReactI18next, withTranslation } from "react-i18next";
import FadeLoader from "react-spinners/FadeLoader";
import Footer from "./footer/Footer";

import i18n from "i18next";
import { trackSession } from "../actions/TrackingActions";
import { getGlobalCode, getUrlWord, injectGlobalCode, isSessionActive, isVideo, showEmbedFooter } from "../util/helpers/Helpers";
import Popup from "reactjs-popup";
import { Cookies } from 'react-cookie';
import $ from "jquery";
import { FormControl, HelpBlock } from "react-bootstrap";

export class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loader: false,
      hash: ""
    };

    this.resizeContainer = this.resizeContainer.bind(this);
    this.setAgeRestrictionAcceptance = this.setAgeRestrictionAcceptance.bind(this);
  }

  setAgeRestrictionAcceptance = () => {
    const cookies = new Cookies();
    console.log('cookie-set-here')
    cookies.set('age-restriction-' + this.props.config.id, true);
    this.setState({
      hideAgeRestrictionPopup: true,
      showEntryCodeModal: true
    });
    // return (this.getEntryCodeModal() );
  }

  showAgeRestrictionPopupError = () => {
    this.setState({
      showAgeRestrictionPopupErr: true
    });
  }

  handleEntryCodeChange = (e) => {
    this.setState({
      entryCode: e.target.value
    });
  };

  redeemEntryCode = () => {

    if (this.state.entryCode && this.state.entryCode != '') {
      let payload = {
        idCompetition: this.props.config.id,
        entryCode: this.state.entryCode
      };

      this.props.dispatch(redeemEntryCode(payload, this.props.dispatch));
    }

  }

  resizeContainer = () => {
    const config = this.props.config;
    const iw = window.innerWidth;

    let useStyle = false;
    let useStyleBg = '';

    if(config.bgColor){
      document.getElementById('root').style.backgroundColor = config.bgColor;
      document.getElementById('root').style.minHeight = '100vh';
    }

    // fallover default
    if (config.desktopBg) {
      useStyle = true;
      useStyleBg = config.desktopBg.file;
    }

    // if (config.desktopBg && iw >= 1024) {
    //   // document.body.style.backgroundImage = `url(${config.desktopBg.file})`;
    //   useStyle = true;
    //   useStyleBg = config.desktopBg.file;
    // }

    if (config.tabletBg && iw < 1024 && iw >= 450) {
      // document.body.style.backgroundImage = `url(${config.tabletBg.file})`;
      useStyle = true;
      useStyleBg = config.tabletBg.file;
    } else if (config.mobileBg && iw < 450) {
      // document.body.style.backgroundImage = `url(${config.mobileBg.file})`;
      useStyle = true;
      useStyleBg = config.mobileBg.file;
    }

    // iphone/ipad background fix
    if (useStyle) {
      const styles = `
          body {
            background: url(${useStyleBg}) no-repeat center center fixed;
          }

          body:after{
            content:"";
            position:fixed; /* stretch a fixed position to the whole screen */
            top:0;
            height:100vh; /* fix for mobile browser address bar appearing disappearing */
            left:0;
            right:0;
            z-index:-1; /* needed to keep in the background */
            background: url(${useStyleBg}) center center;
            -webkit-background-size: cover;
            -moz-background-size: cover;
            -o-background-size: cover;
            background-size: cover;
          }
        `;

      var styleSheet = document.createElement("style");
      styleSheet.innerText = styles;
      document.head.appendChild(styleSheet);
    }


    if (config.name) {
      document.title = config.name.replace(/(<([^>]+)>)/gi, " ").trim();
    }
    window.setTimeout(() => {
      let elHeight = document.body.scrollHeight;
      if (window.self !== window.top) {
        window.parent.postMessage(`benchvoteResize-${elHeight}`, "*");
      }
    }, 500);
  };

  componentDidUpdate(prevProps, prevState, snapshot) {

    console.log("prev-p1", prevProps.entryCode);
    if (!prevProps.entryCode.isRedeemed && this.props.entryCode.isRedeemed) {
      console.log("prev-p2", this.props.entryCode);
      console.log("state-p2", this.state.entryCode);
      console.log('success-p34');
      const cookies = new Cookies();
      // cookies.set('entry-code-' + this.props.config.id, true);
      localStorage.setItem('clx-' + this.props.config.id, this.state.entryCode);
      this.setState({
        hideAgeRestrictionPopup: true
      });
    }

    if (this.props.config.id && !prevProps.config.id) {
      this.resizeContainer();
      this.props.dispatch(trackSession(this.props.config.id, this.props.dispatch));
    }

    //to load language
    if (
      this.props.config &&
      this.props.config.localeId &&
      !prevProps.config.localeId
    ) {
      this.props.dispatch(
        loadLocale(this.props.config.localeId, this.props.dispatch)
      );
      this.props.dispatch(
        loadLocale(this.props.config.localeId, this.props.dispatch)
      );
    }
    if (
      this.props.locale.lang &&
      Object.keys(this.props.locale.lang).length !== 0 &&
      !prevProps.locale.lang.pick_now
    ) {
      setTimeout(() => {
        this.setState({ ...this.state, loader: false });
      }, 500);
      i18n.use(initReactI18next).init({
        lang: this.props.config.localeId,
        fallbackLng: this.props.config.localeId,
        debug: true,
        ns: ["common"],
        defaultNS: "common",
        interpolation: {
          escapeValue: false // not needed for react as it escapes by default
        },
        resources: {
          [this.props.config.localeId]: {
            common: this.props.locale.lang
          }
        }
      });
    }

    if (this.props.config.fontUrl && this.props.config.fontUrl != '') {
      // FONT CSS FILES
      var fileref = document.createElement("link");
      fileref.setAttribute("rel", "stylesheet");
      fileref.setAttribute("type", "text/css");
      fileref.setAttribute("href", this.props.config.fontUrl);
      if (typeof fileref != "undefined") {
        document.getElementsByTagName("head")[0].appendChild(fileref);
      }
    }

    if (this.props.config.cssContent && this.props.config.cssContent != ''
      && this.props.config.cssContentUrl && this.props.config.cssContentUrl != '') {
      // CSS FILES
      var fileref = document.createElement("link");
      fileref.setAttribute("rel", "stylesheet");
      fileref.setAttribute("type", "text/css");
      fileref.setAttribute("href", this.props.config.cssContentUrl);
      if (typeof fileref != "undefined") {
          document.getElementsByTagName("head")[0].appendChild(fileref);
      }
    }

    let allowMultiUserEntry = (this.props.config.allowMultiUserEntry);
    if (this.props.config.id) {
      // allow-multiple
      localStorage.setItem(`${this.props.config.id}-allowMultiUserEntry`, allowMultiUserEntry);
    }

    if (allowMultiUserEntry && !isSessionActive(this.props.config.id)) {
      localStorage.removeItem(`${this.props.config.id}-idOptin`);
      localStorage.removeItem(`${this.props.config.id}-idVote`);
      // investigate and enable this only for first load from home not from offer page
      // localStorage.removeItem(`${this.props.config.id}-offer`);
      // localStorage.removeItem(`${this.props.config.id}-offerViewed`);
    }

    if (!prevProps.globalScript.globalScriptFetched && this.props.globalScript.globalScriptFetched) {
      console.log('propps-ok-new', this.props.globalScript.globalScriptData);
      let gsd = this.props.globalScript.globalScriptData;
      if (gsd && gsd != {}) {
        if (gsd.globalCodeForHeader && gsd.globalCodeForHeader != {}) {
          injectGlobalCode($, 'head', getGlobalCode(gsd.globalCodeForHeader));
        }
        if (gsd.globalCodeForBody && gsd.globalCodeForBody != {}) {
          injectGlobalCode($, 'body', getGlobalCode(gsd.globalCodeForBody));
        }
        if (gsd.globalCodeForFooter && gsd.globalCodeForFooter != {}) {
          injectGlobalCode($, 'footer', getGlobalCode(gsd.globalCodeForFooter));
        }
      }
    }

  }

  componentDidMount() {
    // let hash = this.props.location.hash;
    // hash = hash ? hash.replace(/(^#)/g, "") : "";
    let hash = getUrlWord(this.props.match.url, this.props.location.hash);

    if (hash) {
      this.props.dispatch(getGlobalScriptsForCustomer(hash, this.props.dispatch));
      this.props.dispatch(getConfig(hash, this.props.dispatch));
      this.setState({ hash });
      this.setState({ ...this.state, loader: true });
    }
    this.resizeContainer();
  }

  getEntryCodeModal() {
    const cookies = new Cookies();
    return <Popup
      open={!localStorage.getItem('clx-' + this.props.config.id)}
      contentStyle={{
        width: "auto",
        padding: "0 15px 18px",
        background: "#FFFFFF",
        border: "0px",
        borderRadius: "10px"
      }}
      overlayStyle={{ background: "rgba(0, 0, 0, 0.6)" }}
      lockScroll={true}
      closeOnEscape={false}
      closeOnDocumentClick={false}
    >
      <div className={"age-restrict-dialog"}>
        <div className={"modal-body"}>
          <h3>ENTER YOUR UNIQUE CODE</h3>
        </div>

        {!this.props.entryCode.loading ?
          <div className={"modal-footer"}>

            <div className="optin-row">
              <div className="optin-col">
                <FormControl
                  type='text'
                  // value={oo.value}
                  // placeholder={t(oo.placeholder)}
                  // onFocus={this.sendParentScrollMessage}
                  onChange={e => this.handleEntryCodeChange(e)}
                />
                {/* {this.state.entryCodeError ? ( */}
                {/* <HelpBlock>
                      {this.state.entryCodeError}
                    </HelpBlock> */}
                {/* ) : null} */}
              </div>
            </div>
            <button type="button" className={"btn btn-default btn-entry"}
              onClick={this.redeemEntryCode}>
              <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#FFFFFF">
                <path d="M647-440H160v-80h487L423-744l57-56 320 320-320 320-57-56 224-224Z" />
              </svg>
            </button>
          </div>
          : ''
        }

        {this.props.entryCode.loading ?
          <div className={"modal-error"}>Loading...</div>
          : ''
        }
        {this.props.entryCode.error ?
          <div className={"modal-error"}>{this.props.entryCode.error}</div>
          : ''
        }
      </div>
    </Popup>;
  }


  render() {

    const cookies = new Cookies();
    let modalContent = '';
    console.log('shown', this.props.config);

    if (this.props.config && this.props.config.showAgeRestrictionPopup) {
      modalContent = (
        <Popup
          open={!cookies.get('age-restriction-' + this.props.config.id)}
          contentStyle={{
            width: "auto",
            padding: "0 15px 18px",
            background: "#FFFFFF",
            border: "0px",
            borderRadius: "10px"
          }}
          overlayStyle={{ background: "rgba(0, 0, 0, 0.6)" }}
          lockScroll={true}
          closeOnEscape={false}
          closeOnDocumentClick={false}
        >
          <div className={"age-restrict-dialog"}>
              <div className={"modal-body"}>
                  <h3><Trans i18nKey="are_you_over_18" /></h3>
              </div>
              <div className={"modal-footer"}>
                  <button type="button" className={"btn btn-default"}
                      onClick={this.setAgeRestrictionAcceptance}><Trans i18nKey="yes" /></button>

                  <button type="button" className={"btn btn-default"}
                      onClick={this.showAgeRestrictionPopupError}><Trans i18nKey="no" /></button>
              </div>

              {this.state.showAgeRestrictionPopupErr ?
                  <div className={"modal-error"}><Trans i18nKey="are_you_over_18_err" /></div>
                  : ''
              }
          </div>
        </Popup>
      );
    }

    if (this.props.config && this.props.config.idEntryCodeBatch
        && (this.state.showEntryCodeModal || (this.props.config.showAgeRestrictionPopup
          && cookies.get('age-restriction-' + this.props.config.id))
          || !this.props.config.showAgeRestrictionPopup)) {
      modalContent = (this.getEntryCodeModal());
    }

    return (
      <React.Fragment>

        {this.props && this.props.config && this.props.config.desktopBg
          && this.props.config.desktopBg.file && isVideo(this.props.config.desktopBg.file)
        ? <video autoPlay={true} muted={true} loop={true} id="myVideo">
              <source src={this.props.config.desktopBg.file} type="video/mp4"/>
        </video> : null}

        {this.state.loader ? (
          <div className={"loaderCss"}>
            <div className={"loader"}>
              <FadeLoader
                size={150}
                color={"#ffffff"}
                loading={this.state.loader}
              />
            </div>
          </div>
        ) : null}
        {modalContent}
        <div className={"main-cont"}>{this.props.children}</div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    ...ownProps,
    config: state.default.data.config,
    locale: state.default.locale,
    globalScript: state.default.data.globalScript,
    entryCode: state.default.data.entryCode,
  };
};


const mapDispatchToProps = dispatch => {
  return {
      dispatch
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(App));
